// src/enums/DeviceTypes.js
export const DeviceTypes = {
  HOME: {
    id: "home",
    label: "خانه",
    icon: "img/icons/home.webp", // Updated to webp path
  },
  SHOP: {
    id: "shop",
    label: "فروشگاه",
    icon: "img/icons/shopping.webp",
  },
  PERSON: {
    id: "person",
    label: "اداره",
    icon: "img/icons/office.webp",
  },
  BUILDING: {
    id: "building",
    label: "ویلا",
    icon: "img/icons/villa.webp",
  },
  FACTORY: {
    id: "factory",
    label: "کارخانه",
    icon: "img/icons/factory.webp",
  },
};

// Array of all device types for easy iteration
export const DeviceTypeList = [
  DeviceTypes.HOME,
  DeviceTypes.SHOP,
  DeviceTypes.PERSON,
  DeviceTypes.BUILDING,
  DeviceTypes.FACTORY,
];
